import { coeffect, effects, registerEventHandler } from 'reffects';
import { state } from 'reffects-store';
import { globals } from 'reffects-batteries';

export default function registerEvents() {
    registerEventHandler(
        'INITIALIZE_SUPPORT_FOR_UKRAINE',
        function initializeSupportForUkraine({
            globals: {
                trovitData: { hasBillingData, isDefaulter, source },
            },
            currentLocation,
        }) {
            return {
                ...state.set({
                    isDefaulter,
                    hasBillingData,
                    source,
                    currentLocation,
                }),
                ...effects.dispatch('LOAD_CONFIG', {
                    configName: 'SHOW_SUPPORT_FOR_UKRAINE',
                }),
            };
        },
        [globals.get('trovitData'), coeffect('currentLocation')]
    );
}
